export const EmailAddress ="service@thermalsystems.ca";
export const ContactNumber ="403-230-6739";